import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTSANTS = {
    description:
      "High passionate Full Stack .NET Developer with 1 year of experience, excelling in web and desktop applications. Stays current with the latest .NET technologies and consistently delivers high-quality solutions. Expertise covers the entire development cycle, with additional training from the Information Technology Institute (ITI).",
    highlights: {
      bullets: [
        "Full Stack development ,NET",
        "C#, .NET Core, ASP.NET (API & MVC)",
        "HTML5, CSS3, Bootstrap, jQuery, Ajax, JavaScript, React, Angular",
        "Building Rest API",
        "SQL Server, PostgreSQL, SQLite LINQ, Entity framework Core.",
        "Git, GitHub, Azure DevOps",
        "Scrum Methodologies",
        "Design Patterns",
        "SOLID and Design Logic (Domain Driven Design)",
      ],
      heading: "Here are a Few Highlights:",
    },
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div className="about-me-container screen-container fade-in" id={props.id || ""}>
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTSANTS.description}
            </span>
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span>{SCREEN_CONSTSANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <button
                className="btn primary-btn"
                onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              >
                {" "}
                Hire Me{" "}
              </button>
              <a href="PeterMamdouhYoussef.pdf" download="Peter Mamdouh CV.pdf">
                <button className="btn highlighted-btn">Get Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
